import { RefObject, useEffect } from "react";

const scormFrames = new Set<RefObject<HTMLIFrameElement>>();
let originalWindowClose: typeof window.close | undefined;

const closeWindowUnlessTriggeredByScorm = () => {
	const isScormFocused = Array.from(scormFrames).some(({ current }) => current === document.activeElement);

	if (!isScormFocused) originalWindowClose?.call(window);
};

export const usePreventScormWindowClose = (frameRef: RefObject<HTMLIFrameElement>) => {
	useEffect(() => {
		if (scormFrames.size === 0) {
			originalWindowClose = window.close;
			window.close = closeWindowUnlessTriggeredByScorm;
		}

		scormFrames.add(frameRef);

		return () => {
			scormFrames.delete(frameRef);

			if (scormFrames.size === 0 && originalWindowClose) {
				window.close = originalWindowClose;
				originalWindowClose = undefined;
			}
		};
	}, [frameRef]);
};
